import bootstrap from '@/bootstrap';
import Privacy from '@/templates/pages/Privacy.vue';
bootstrap(Privacy);
